import { request } from './client';

export type LogEntry = {
	timestamp: string | null;
	level: string;
	message: string;
	context: Record<string, unknown> | null;
};

export type LogStats = {
	enabled: boolean;
	total_files: number;
	total_size_formatted: string;
	current_file_exists: boolean;
};

export type LogsData = {
	logs: LogEntry[];
	stats: LogStats;
};

export const logsApi = {
	get: (lines = 200) =>
		request<LogsData>(`/logs?lines=${lines}`),
	clear: () =>
		request<{ cleared: boolean }>('/logs', { method: 'DELETE' }),
};
